"use client"

import { Skeleton } from "@/components/ui/skeleton"
import { PromotionListSkeletonProps } from "@/types/types"

export function PromotionListSkeleton({
  slidesPerView = 3,
  spaceBetween = 20,
  className = "",
}: PromotionListSkeletonProps) {
  return (
    <div className={`promotion-list-container ${className}`}>
      <div className="container max-w-full sm:max-w-[1290px] mx-auto px-4 py-8 lg:py-16">
        <div className="flex items-start lg:items-center justify-between mb-5 lg:mb-3">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-2.5 lg:gap-4">
            <Skeleton className="h-7 lg:h-9 w-32 lg:w-40 rounded" />
            <Skeleton className="h-8 w-16 lg:w-20 rounded-full" />
          </div>
          <Skeleton className="h-5 lg:h-6 w-20 lg:w-24 rounded" />
        </div>

        <div className="relative">
          <Skeleton className="absolute left-5 top-[45%] -translate-y-1/2 z-10 w-7 h-7 rounded-full hidden md:block" />
          <Skeleton className="absolute right-5 top-[45%] -translate-y-1/2 z-10 w-7 h-7 rounded-full hidden md:block" />

          <div className="promotion-list-swiper-skeleton">
            <div className="flex gap-4 md:hidden overflow-hidden">
              {Array.from({ length: 3 }).map((_, index) => (
                <div
                  key={`mobile-${index}`}
                  className="flex-shrink-0"
                  style={{
                    width: `calc((100vw - 2rem - ${spaceBetween * 2}px) / 1.4)`,
                    maxWidth: `calc((100% - ${spaceBetween * 2}px) / 1.4)`,
                  }}
                >
                  <Skeleton className="w-full h-[160px] rounded-lg" />
                </div>
              ))}
            </div>

            <div className="hidden md:flex lg:hidden gap-5 overflow-hidden">
              {Array.from({ length: 2 }).map((_, index) => (
                <div
                  key={`tablet-${index}`}
                  className="flex-shrink-0"
                  style={{ width: `calc((100% - ${spaceBetween}px) / 2)` }}
                >
                  <Skeleton className="w-full h-[280px] rounded-lg" />
                </div>
              ))}
            </div>

            <div className="hidden lg:flex gap-5 overflow-hidden">
              {Array.from({ length: slidesPerView }).map((_, index) => (
                <div
                  key={`desktop-${index}`}
                  className="flex-shrink-0"
                  style={{ width: `calc((100% - ${spaceBetween * (slidesPerView - 1)}px) / ${slidesPerView})` }}
                >
                  <Skeleton className="w-full h-[280px] rounded-lg" />
                </div>
              ))}
            </div>

            <div className="flex justify-center gap-2 mt-8 md:hidden pb-10">
              {Array.from({ length: 3 }).map((_, index) => (
                <Skeleton
                  key={`pagination-${index}`}
                  className="h-1 w-6 rounded"
                  style={{ opacity: index === 0 ? 1 : 0.5 }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
